<template>
  <div class="visitor">
    <div class="header_content">
      <div class="left" @click="$router.go(-1)">
        <i class="el-icon-arrow-left"></i>
        <span>返回</span>
      </div>
      <div class="right">
        放行号：<span>{{ info.releaseNumber }}</span>
      </div>
    </div>
    <div class="content">
      <div class="title">
        <div class="line"></div>
        <div class="titleName">登记信息</div>
      </div>
      <div class="content_list">
        <div class="list_item">
          <div class="name name1">姓名</div>
          <div class="value">：{{ info.driverName }}</div>
        </div>
        <div class="list_item">
          <div class="name name1">来访时间</div>
          <div class="value">：{{ info.visitorTime }}</div>
        </div>
        <div class="list_item">
          <div class="name name2">自带货物名称</div>
          <div class="value">：{{ info.productName }}</div>
        </div>
      </div>
      <div class="content_list">
        <div class="list_item">
          <div class="name name1">电话</div>
          <div class="value">：{{ info.visitorPhone }}</div>
        </div>
        <div class="list_item">
          <div class="name name1">车牌号码</div>
          <div class="value">：{{ info.carNumber }}</div>
        </div>
        <div class="list_item">
          <div class="name name2">货物数量/重量</div>
          <div class="value">：{{ info.quantityWeight }}</div>
        </div>
      </div>
      <div class="content_list">
        <div class="list_item">
          <div class="name name1">单位名称</div>
          <div class="value">：{{ info.visitorDept }}</div>
        </div>
        <div class="list_item">
          <div class="name name1">车辆类型</div>
          <div class="value">
            ：{{
              info.vehicleType == 1
                ? "货车"
                : info.vehicleType == 2
                ? "面包车"
                : info.vehicleType == 3
                ? "三轮车"
                : ""
            }}
          </div>
        </div>
        <div class="list_item">
          <div class="name name1"></div>
          <div class="value"></div>
        </div>
      </div>
      <div class="content_list">
        <div class="list_item">
          <div class="name name1">备注</div>
          <div class="value value1">：{{ info.remarkReasons }}</div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="title">
        <div class="line"></div>
        <div class="titleName">放行信息</div>
      </div>
      <div class="content_list">
        <div class="list_item">
          <div class="name name1">部门</div>
          <div class="value">：{{ info.createrDepartment }}</div>
        </div>
        <div class="list_item">
          <div class="name name3">申请人</div>
          <div class="value">：{{ info.createrName }}</div>
        </div>
        <div class="list_item" v-if="info.releaseType == 1">
          <div class="name name2">物品类型</div>
          <div class="value">：{{ info.itemType }}</div>
        </div>
        <div class="list_item" v-else>
          <div class="name name2">放行人员类型</div>
          <div class="value">：{{ info.personnelType }}</div>
        </div>
      </div>
      <div class="content_list">
        <div class="list_item">
          <div class="name name1">放行人员</div>
          <div class="value">：{{ info.driverName }}</div>
        </div>
        <div class="list_item" v-if="info.driverCode">
          <div class="name name3">工号</div>
          <div class="value">：{{ info.driverCode }}</div>
        </div>
        <div class="list_item" v-if="info.department">
          <div class="name name2">放行人员部门</div>
          <div class="value">：{{ info.department }}</div>
        </div>
        <div class="list_item" v-if="!info.department || !info.driverCode">
          <div class="name name2">手机号码</div>
          <div class="value">：{{ info.visitorPhone }}</div>
        </div>
        <div class="list_item" v-if="!info.department || !info.driverCode">
          <div class="name name1">预计送回时间</div>
          <div class="value">：{{ info.arriveDate }}</div>
          <div class="name name1">预计送回时间</div>
          <div class="value">：{{ info.arriveDate }}</div>
        </div>
      </div>
      <div class="content_list">
        <div class="list_item" v-if="info.driverCode || info.department">
          <div class="name name2">手机号码</div>
          <div class="value">：{{ info.visitorPhone }}</div>
        </div>
        <div class="list_item" v-if="info.driverCode || info.department">
          <div class="name name1">预计送回时间</div>
          <div class="value">：{{ info.arriveDate }}</div>
        </div>
        <div class="list_item">
          <div class="name name4">携带物品是否送回公司</div>
          <div class="value">：{{ info.sendBack == 1 ? "否" : "是" }}</div>
        </div>
        <div class="list_item" v-if="!info.department || !info.driverCode">
          <div class="name name2"></div>
          <div class="value"></div>
        </div>
        <div class="list_item" v-if="!info.department || !info.driverCode">
          <div class="name name2"></div>
          <div class="value"></div>
        </div>
      </div>
      <div class="content_list">
        <div class="list_item">
          <div class="name name1">放行门卫</div>
          <div class="value">：{{ info.userName }}</div>
        </div>
        <div class="list_item">
          <div class="name name3">放行时间</div>
          <div class="value">：{{ info.releaseDate }}</div>
        </div>
        <div class="list_item">
          <div class="name name2">放行门卫手机号</div>
          <div class="value">：{{ info.phone }}</div>
        </div>
      </div>

      <div class="content_list">
        <div class="list_item">
          <div class="name name1">备注</div>
          <div class="value value1">：{{ info.remark }}</div>
        </div>
      </div>
      <div class="content_list">
        <div class="list_item1">
          <div class="name name1">放行物品：</div>
          <div class="table_content">
            <div class="table_header">
              <div class="left">物品名称</div>
              <div class="right">数量</div>
            </div>
            <div
              class="item_content"
              v-for="(item, index) in info.goods"
              :key="index"
            >
              <div class="item_left">{{ item.goodsName }}</div>
              <div class="item_right">{{ item.goodsNumber }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="content_list">
        <div class="list_item1">
          <div class="name name1">拍照附件：</div>
          <div class="value value1">
            <img
              :src="item.url"
              alt=""
              v-for="(item, index) in info.beforeList"
              :key="index"
              style="width: 100px; height: 100px; margin-right: 20px"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/apis";
import apiss from "@/apis/medal";
export default {
  name: "carReleaseDetail",
  data() {
    return {
      info: {}
    };
  },
  watch: {},
  mounted() {
    this.queryDetailsRelease();
  },
  methods: {
    // 详情
    queryDetailsRelease() {
      api.queryDetailsRelease({ id: this.$route.query.id }).then(res => {
        if (res.code == 200) {
          this.info = res.data;
          if (res.data.fileIds) {
            const fileIds = res.data.fileIds.split(",");
            this.info.beforeList = fileIds.map(item => {
              return {
                url: apiss.imgUrl + item,
                isImage: true
              };
            });
          } else {
            // this.beforeList = [];
            this.info.beforeList = [];
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.visitor {
  height: calc(100vh - 75px);
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 0px;
    height: 1px;
    background-color: rgba(240, 240, 240, 1);
  }
  .header_content {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    margin-bottom: 5px;
    .left {
      font-size: 13.5px;
      color: #18191e;
      span {
        font-size: 13px;
        margin-left: 10px;
      }
    }
    .right {
      font-size: 11.5px;
      color: #666666;
      span {
        color: #388654;
      }
    }
  }
  .content {
    padding: 10px 6px;
    .title {
      line-height: 11px;
      height: 100%;
      display: flex;
      align-items: center;
      .line {
        width: 2px;
        height: 11px;
        background: #388654;
      }
      .titleName {
        font-weight: bold;
        font-size: 11px;
        color: #18191e;
        margin-left: 5px;
      }
    }
    .content_list {
      // width: 60%;
      display: flex;
      align-items: center;
      margin: 10px 0;
      .list_item {
        width: 300px;
        display: flex;
        align-items: flex-start;
        .name {
          text-align-last: justify;
          text-align: justify;
          font-family: MicrosoftYaHei;
          font-size: 10.5px;
          color: #666666;
          flex-shrink: 0;
        }
        .name1 {
          width: 70px;
        }
        .name2 {
          width: 80px;
        }
        .name3 {
          text-align: right;
          width: 70px;
          font-family: MicrosoftYaHei;
          font-size: 10.5px;
          color: #666666;
          flex-shrink: 0;
        }
        .name4 {
          width: 110px;
        }
        .value {
          flex-shrink: 0;
          color: #282b32;
          font-size: 10.5px;
          word-break: break-all;
        }
        .value1 {
          width: calc(100vw - 170px);
        }
      }
      .list_item1 {
        .name {
          text-align-last: justify;
          text-align: justify;
          font-family: MicrosoftYaHei;
          font-size: 10.5px;
          color: #666666;
          flex-shrink: 0;
        }
        .name1 {
          width: 60px;
        }
      }
      .table_content {
        background-color: #fff;
        width: 258px;
        margin-top: 10px;
        .table_header {
          height: 26.5px;
          border: 1px solid #dfdfdf;
          background: #f7f9fa;
          font-weight: bold;
          font-size: 10.5px;
          color: #333333;
          display: flex;

          width: 100%;
          .left {
            width: 70%;
            display: flex;
            justify-content: center;
            align-content: center;
            flex-wrap: wrap;
            border-right: 1px solid #dfdfdf;
          }
          .right {
            width: 30%;
            display: flex;
            justify-content: center;
            align-content: center;
            flex-wrap: wrap;
          }
        }
        .item_content {
          height: 26.5px;
          border: 1px solid #dfdfdf;
          border-top: 0;
          display: flex;
          font-size: 9px;
          .item_left {
            width: 70%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex-wrap: wrap;
            border-right: 1px solid #dfdfdf;
            padding-left: 10px;
          }
          .item_right {
            width: 30%;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
          }
        }
      }
    }
  }
}
</style>
